/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import { UploadBox, CheckBox } from "../../components/Input";
import { PermissionWrapper, hasPermission } from "../../helpers/permission.js";
import LoadingSpinner from "../../components/LoadingSpinner";

const AddFolioPushNotification = () => {
    const [loading, setLoading] = useState(false);
    const [servicesOptions, setServicesOptions] = useState([]);
    const [uploadKey, setUploadKey] = useState(0);
    const [formData, setFormData] = useState({
        title: "",
        usertype: "0",
        serviceid: "",
        message: "",
        src_url: "",
        notify_image: null,
        deeplink: "notification",
        customerid: "1", // Added customerid field
    });

    const usertypeOptions = [
        { value: "0", label: "All Users" },
        { value: "1", label: "Paid Active" },
        { value: "2", label: "Paid Expired" },
        { value: "3", label: "Free Active" },
        { value: "4", label: "Free Expired" },
        { value: "5", label: "All Active" },
        { value: "6", label: "All Expired" },
    ];

    // Fetch services from API
    const fetchServices = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(`${API_URL}service/portfolio-services`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.data && response.data.success) {
                // Transform API data to match the required format
                const services = response.data.data.map(service => ({
                    value: service.id.toString(),
                    label: service.service_name
                }));
                setServicesOptions(services);
            } else {
                showToast.error("Failed to fetch services");
                setServicesOptions([]);
            }
        } catch (error) {
            console.error("Error fetching services:", error);
            showToast.error("Error loading services");
            setServicesOptions([]);
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => {
        const handleClearEvent = () => {
            handleClear();
        };

        window.addEventListener('clearFolioPushNotificationFiltersEvent', handleClearEvent);
        return () => {
            window.removeEventListener('clearFolioPushNotificationFiltersEvent', handleClearEvent);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData((prev) => ({
            ...prev,
            notify_image: file,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.title.trim()) {
            showToast.error("Please enter title");
            return;
        }

        if (!formData.message.trim()) {
            showToast.error("Please enter message");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");

            // Create FormData object
            const formDataToSend = new FormData();

            // Add all form fields to FormData
            formDataToSend.append("customerid", formData.customerid);
            formDataToSend.append("title", formData.title.trim());
            formDataToSend.append("message", formData.message.trim());
            formDataToSend.append("usertype", formData.usertype);
            formDataToSend.append("serviceid", formData.serviceid);
            formDataToSend.append("src_url", formData.src_url.trim());
            formDataToSend.append("deeplink", formData.deeplink);

            // Add file if selected
            if (formData.notify_image) {
                formDataToSend.append("src_url", formData.notify_image);
            }

            // Build URL
            const url = `${API_URL}FolioPushNotification/save`;

            console.log("Sending data to:", url);

            const response = await axios.post(url, formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                    Accept: "*/*",
                },
            });

            if (response.data && response.data.success) {
                showToast.success("Folio Notification saved successfully");
                // Reset form after successful submission
                setFormData({
                    title: "",
                    usertype: "0",
                    serviceid: "",
                    message: "",
                    src_url: "",
                    notify_image: null,
                    deeplink: "notification",
                    customerid: "1",
                });
                setUploadKey(prev => prev + 1);
            } else {
                const errorMessage = response.data?.message || "Failed to save folio notification";
                showToast.error(errorMessage);
            }
        } catch (error) {
            console.error("Error saving folio notification:", error);
            const errorMessage = error.response?.data?.message || "Failed to save folio notification";
            showToast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setFormData({
            title: "",
            usertype: "0",
            serviceid: "",
            message: "",
            src_url: "",
            notify_image: null,
            deeplink: "notification",
            customerid: "1",
        });
        setUploadKey(prev => prev + 1);
    };

    return (
        <div className="page-container mt-5">
            {/* Loading Spinner */}
            {loading && (
                <LoadingSpinner />
            )}

            {/* Breadcrumb */}
            <div className="d-flex align-items-center justify-content-between mb-3 flex-column flex-md-row">
                <div className="d-flex align-items-center mb-2 mb-md-0">
                    <Link to="/" className="text-primary text-decoration-none">
                        <i className="fas fa-home me-1"></i> Home
                    </Link>
                    <span className="mx-2">/</span>
                    <span>Manage Folio Notifications</span>
                </div>
                <div className="d-flex flex-wrap justify-content-end notification-buttons-container">
                    <a
                        className="btn btn-default btn-sm me-2 mb-1"
                        href="/Campaign/FolioGeneralNotification"
                        target="_blank"
                    >
                        General Notification
                    </a>
                    <a
                        className="btn btn-default btn-sm me-2 mb-1"
                        href="/Campaign/FolioIndividualNotification"
                        target="_blank"
                    >
                        Individual Notification
                    </a>
                    {/* <a
                        className="btn btn-default btn-sm mb-1"
                        href="/Campaign/FolioResearchNotification"
                        target="_blank"
                    >
                        Research Notification
                    </a> */}
                </div>
            </div>

            <style>{`
        .notification-buttons-container {
          width: 100%;
          max-width: 500px;
        }
        
        @media (max-width: 767px) {
          .notification-buttons-container {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 8px;
            padding-bottom: 5px;
          }
          
          .notification-buttons-container .btn {
            flex: 0 0 auto;
            white-space: nowrap;
            font-size: 0.85rem;
            padding: 6px 12px;
          }
          
          .notification-buttons-container .btn.me-2 {
            margin-right: 0 !important;
          }
        }
      `}</style>

            <div className="panel panel-default with-rounded-corner with-shadow">
                <div className="panel-heading">
                    <span className="panel-title">Manage Folio Notifications</span>
                </div>
                <div className="panel-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="row">
                            <input
                                type="hidden"
                                name="customerid"
                                value={formData.customerid}
                            />

                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Title <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Title"
                                    disabled={loading}
                                    required
                                />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label">User</label>
                                <select
                                    name="usertype"
                                    value={formData.usertype}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    disabled={loading}
                                >
                                    {usertypeOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label">Services</label>
                                <select
                                    name="serviceid"
                                    value={formData.serviceid}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    disabled={loading}
                                >
                                    <option value="">Select Service</option>
                                    {servicesOptions.map((service) => (
                                        <option key={service.value} value={service.value}>
                                            {service.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-12 mb-3">
                                <label className="form-label">
                                    Message <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Message"
                                    rows="4"
                                    disabled={loading}
                                    required
                                ></textarea>
                            </div>

                            <div className="col-md-12 mb-3">
                                <label className="form-label">Url</label>
                                <input
                                    type="url"
                                    name="src_url"
                                    value={formData.src_url}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Url"
                                    disabled={loading}
                                />
                            </div>

                             <div className="col-md-4 mb-3">
                                 <div className="row">
                                     <div className="col-md-12">
                                         <UploadBox
                                             key={uploadKey}
                                             label="Notification Image"
                                             fieldname="notification_image"
                                             onChange={handleFileChange}
                                             disabled={loading}
                                         />
                                     </div>
                                 </div>
                             </div>

                             <div className="col-md-4 mb-3">
                                 <label className="form-label">Screen Redirection</label>
                                 <select
                                     name="deeplink"
                                     value={formData.deeplink}
                                     onChange={handleInputChange}
                                     className="form-control"
                                     disabled={loading}
                                 >
                                     <option value="">Select Screen Redirection</option>
                                     <option value="notification">General - notification - Default</option>
                                     <option value="folios">Explore Screen - folios</option>
                                     <option value="streetfolioDetail">Streetfolio Detail - streetfolioDetail</option>
                                 </select>
                             </div>

                            <div className="col-md-12 mb-3">
                                <div className="d-flex">
                                    <PermissionWrapper module="folio_pushnotifications" action="add">
                                        <button
                                            type="submit"
                                            name="submit"
                                            className="btn btn-primary me-2"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Saving...
                                                </>
                                            ) : (
                                                'Submit'
                                            )}
                                        </button>
                                    </PermissionWrapper>
                                    <button
                                        type="button"
                                        name="clearall"
                                        className="btn btn-danger"
                                        onClick={handleClear}
                                        disabled={loading}
                                    >
                                        Clear All
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div id="myModal" className="modal">
                <div className="modal-dialog panel panel-default panel-border top">
                    <div className="modal-content">
                        <div id="myModalContent"></div>
                    </div>
                </div>
            </div>

            <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
                <i className="ti-arrow-up"></i>
            </a>
        </div>
    );
};

export default AddFolioPushNotification;
